import { jsx as _jsx } from "react/jsx-runtime";
import { Platform, requireNativeComponent } from "react-native";
var isAvailable = Platform.OS === "ios" && !Platform.isTV;
var MenuActionNative = isAvailable ? requireNativeComponent("OneMenuAction") : null;
function MenuAction(props) {
  if (!MenuActionNative) return null;
  var { image, onSelected, ...rest } = props;
  return /* @__PURE__ */ _jsx(MenuActionNative, {
    ...rest,
    imageSource: image,
    onSelected: onSelected ? function() {
      return onSelected();
    } : void 0
  });
}
export {
  MenuAction
};
//# sourceMappingURL=index.native.js.map
